import React, { useState } from "react";

import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, Stack } from "@mui/material";
import { FileViewer, Menu, MenuProps } from "components/popups";
import { IFile } from "store/types";

interface Props {
  file: IFile;
  menuOptions?: MenuProps["options"];
  showMenu?: boolean;
  onFocus?: () => void;
}

export const FileBlock: React.FC<Props> = ({ file, menuOptions = [], showMenu = true, onFocus }) => {
  const [isFilePreviewOpen, setIsFilePreviewOpen] = useState<boolean>(false);
  const previewFile = () => setIsFilePreviewOpen(true);
  return (
    <>
      <Box
        onFocus={onFocus}
        tabIndex={0}
        sx={{
          backgroundColor: "#f5f7f7",
          border: "1px solid transparent",
          minHeight: "30px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: "37px",
          padding: "0px 10px 0px 13px",
          fontSize: "13px",
          "&:hover": {
            border: "1px solid #dae0e2",
            ".MuiIconButton-root": {
              opacity: "1"
            }
          }
        }}
      >
        <Stack
          onClick={previewFile}
          display="flex"
          flexDirection="row"
          gap="6px"
          alignItems="center"
          sx={{ cursor: "pointer" }}
        >
          <InsertDriveFileOutlinedIcon sx={{ color: "#0a3142" }} />
          <span style={{ color: "#0a3142" }}>{file.name}</span>
          <span>{file.size_in_bytes / 1000}KB</span>
        </Stack>
        {showMenu && (
          <Menu
            iconButtonProps={{
              sx: { padding: 0, width: "20px", height: "20px", color: "#5d7782" }
            }}
            icon={<MoreHorizIcon sx={{ fontSize: 16 }} />}
            horizontalTrigger
            keepTriggerEnabled
            options={menuOptions}
          />
        )}
      </Box>
      <FileViewer isOpen={isFilePreviewOpen} onClose={() => setIsFilePreviewOpen(false)} file={file} />
    </>
  );
};
